import * as fromOrder from './order.actions';
import { Order, IOrder } from '../models/order.model';

export interface OrderState {
    order: IOrder;
}

const estadoInicial: OrderState = {
    order: null
};


export function orderReducer(state = estadoInicial, action: fromOrder.acciones): OrderState {

    switch (action.type) {

        case fromOrder.SET_ORDER:
            return {
                ...state,
                order: action.order
            };

        case fromOrder.UNSET_ORDER:
            return {
                order: null
            };

        default:
            return state;

    }

}